export const UnderlinedCurrencyEditorStyle: React.CSSProperties = {
  border: 'none',
  borderBottom: '1px solid #1976d2',
  outline: 'none',
  background: 'transparent',
  width: '100%',
  fontSize: '14px',
  textAlign: 'right',
};

export interface UnderlinedCurrencyEditorProps {
  value: string;
  onValueChange: (value: string) => void;
  eGridCell: HTMLElement;
}

export const UnderlinedCurrencyEditor = ({
  value,
  onValueChange,
  eGridCell,
}: UnderlinedCurrencyEditorProps): JSX.Element => {
  eGridCell.classList.remove('ag-cell-inline-editing');
  return (
    <input
      autoFocus={true}
      type="text"
      style={UnderlinedCurrencyEditorStyle}
      value={value || ''}
      onChange={({ target: { value } }) => {
        const cleaned = value?.replace(/[^0-9.]/g, '') ?? '';
        onValueChange(cleaned);
      }}
    />
  );
};
